import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import en from 'react-phone-number-input/locale/en.json';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import * as locals from '@ivymobi/orbit-core/business/phoneNumber'

import {
  Box, Typography, IconButton, Button, DialogTitle, InputAdornment,
  TextField, MenuItem, FormControl, InputLabel, Select,
} from '@mui/material';
import Close from '@mui/icons-material/Close';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

// 工具方法
import { get } from 'lodash';
import clsx from 'clsx';
import { Form } from '../../components';
import { SendSmsCodeButton } from '../../users/smsCode';

// 引用的组件
// import { Form } from '../../components';
// import { SendSmsCodeButton } from '../../users/smsCode';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    boxStyle1: {
      width: '40px',
      height: '40px',
      borderRadius: '20px',
      border: '1px solid #d1d1d1'
    },
    boxStyle2: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: theme.spacing(3.75),
      cursor: 'pointer',
    },
    image1: {
      width: '40px',
      height: '40px',
      padding: '5px'
    }

  }),
);




export default function LoginForm(props) {
  const classes = useStyles();
  const [t,i18n] = useTranslation();
  const lan = i18n.language === 'zh-CN' ? 'zh' : i18n.language;
  const [flush, setFlush] = useState(true);

  const {
    user, doSendCode, onSubmit, onClose, share
  } = props;
  const { tenant } = share;
  // const { info } = tenant;
  // const { industries = [] } = info;
  const userPhone = user?.phone;

  const { register, handleSubmit, errors, getValues, watch, formState, setValue } = useForm<{
    mobile: string;
    code: string;
    countryCode: string;
  }>({ mode: 'onChange', defaultValues: { mobile: '', code: '', countryCode: '+86' } });
  const mobile = watch('mobile');
  register({ name: 'countryCode' });

  const handleChange = (event) => {
    setValue('countryCode', '+' + event.target.value);
    setFlush(!flush);
    // console.log('======', getValues('countryCode').replace('+', ''));
  };

  const CountrySelect = ({ labels }) => {
    return (
      <FormControl fullWidth required >
        <InputLabel style={{marginLeft:'-15px'}} id="demo-simple-select-label">{'国家'}</InputLabel>
        <Select
        variant='standard'
          name='countryCode'
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={getValues('countryCode').replace('+', '')}
          label="countryCode"
          onChange={handleChange}
        >
          {getCountries().map((country) => (
            <MenuItem key={country} value={getCountryCallingCode(country)}>{labels[country]}</MenuItem>

          ))}
        </Select>
      </FormControl>
    );
  };
  return (
    <>
      <Box zIndex={999} display='flex' justifyContent='space-between' >
        <Box display='flex' justifyContent='center' width='100%'>
          <DialogTitle>
            {/* 222222222222222 没有token时弹框 */}
            {'登录'}
          </DialogTitle>
        </Box>
        <IconButton onClick={onClose} ><Close /></IconButton>
      </Box>
      <Form
        onSubmit={(e) => console.log(e)}
        toolbar={null}
        defaultValues={formState} pb={3}
      >
        { !userPhone &&
          <CountrySelect
            labels={locals.getCurLanuagePhone(i18n)}
            value={getValues('countryCode')}
            onChange={(e) => console.log(e)}
          />
        }
        <TextField
        variant='standard'
          label={'手机号码'}
          placeholder={'请输入手机号码'}
          fullWidth
          margin="normal"
          name="mobile"
          required
          inputRef={register({ required: true, minLength: 11,maxLength:11 })}
          error={Boolean(errors.mobile)}
          helperText={errors.mobile ? '请输入有效的手机号' : ''}
          InputProps={{
            startAdornment: <InputAdornment position="start">{getValues('countryCode')}</InputAdornment>,
          }}
        />
        { !userPhone &&
          <TextField
          variant='standard'
            label={'验证码'}
            placeholder={'请输入验证码'}
            fullWidth
            margin="normal"
            name="code"
            required
            autoComplete="off"
            inputRef={register({ required: true, minLength: 3 })}
            error={Boolean(errors.code)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ marginBottom: '24px' }}>
                  <SendSmsCodeButton
                    disabled={Boolean((mobile || '').length === 0 || errors.mobile)}
                    doSendCode={() => doSendCode(mobile)}
                  />
                </InputAdornment>
              )
            }}
          />
        }
        <Box style={{ fontSize: '12px' }}>
            提交表示已同意
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={tenant?.tnt_info?.fileurl}
          >
            {'《' + tenant?.tnt_info?.filename + '》'}
          </a>
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          onClick={() => {
            onSubmit({ mobile: getValues('mobile'), code: getValues('code'), countryCode: getValues('countryCode') });

          }}
          disabled={!(formState.isValid && formState.isDirty)}
        >
          {'登录'}
        </Button>
      </Form>
    </>
  );
}